<template>
  <basic-dialog
    :visible="visible"
    :title="title"
    :width="1100"
    :showFt="false"
    :update-vis="updateVis"
    :handle-close="handleClose"
    :handle-closed="handleClosed"
    :handle-ok="handleOk"
  >
    <el-form
      ref="form"
      size="small"
      label-position="right"
      label-width="80px"
      :model="dto"
      :rules="rules"
      :inline="true"
      @submit.native.prevent
    >
      <div class="entity-dlg__block">
        <div class="entity-dlg__block-bd formFix">
          <el-row :gutter="0">
            <el-form-item :label="$t('language.5o6umf8wpe40')">
              <el-select v-model="typeItem"  :placeholder="$t('language.5o6umf8wpe40')" @change="dtTypeChange">
                <el-option
                  v-for="(item, ind) in dataType"
                  :label="item.typeName"
                  :value="item.typeCode"
                  :key="ind"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="item.name"
              v-for="(item, index) in dataExtInfoList"
              :key="index"
            >
              <!-- <el-input v-if="item.type === 'input'" v-model="searchList[item.key]" clearable /> -->
              <el-autocomplete
                v-if="item.type === 'input'"
                v-model.trim="searchList[item.key]"
                :debounce="500"
                :fetch-suggestions="(value, cb) => querySearchThink(value, cb, item.key)"
                :placeholder="$t('language.5o6umf8wq2o0') + item.name"
                :maxlength="30"
                clearable
              >
              </el-autocomplete>
              <el-select
                v-else-if="item.type === 'enums'"
                v-model="searchList[item.key]"
                :placeholder="$t('language.5o6u3f3cnok0')"
                clearable
                filterable
              >
                <el-option
                  v-for="subItem in item.enums"
                  :key="subItem.code"
                  :label="subItem.label"
                  :value="subItem.value"
                />
              </el-select>
            </el-form-item>
            <div class="col-r">
              <el-button type="primary" size="small" @click="query">{{$t('language.5o6trh9vn600')}}</el-button>
              <el-button size="small" @click="handleReset">{{$t('language.5o6trh9vn900')}}</el-button>
            </div>
          </el-row>
        </div>
      </div>
    </el-form>
    <template>
      <basic-list
        :show-select-col="false"
        :show-action-col="false"
        :loading="false"
        ref="adminTB"
        :showActionCol="true"
        :actionColLabel="$t('language.5oeakql17mm1')"
        :isActionRender="false"
        :fields="fields"
        :total="adminList ? adminList.total : 0"
        :list="adminList ? adminList.list : []"
        :selection-change="selectionChange"
        :page-index-change="pageIndexChange"
        :page-size-change="pageSizeChange"
        :page-size="pageSize"
      >
        <template v-slot:action="row">
          <el-popover placement="top" trigger="click">
            <div>
              <el-alert
                :title="$t('language.5orakql17mm1')"
                type="info"
                :closable="false"
                style="margin-bottom: 10px"
              >
              </el-alert>
              <el-table :data="dataCodeArray" border style="width: 100%">
                <el-table-column prop="source" :label="$t('language.5o6upp1vorc0')" width="200px">
                </el-table-column>
                <el-table-column prop="detail" :label="$t('language.5o6upp1vouc0')"> </el-table-column>
              </el-table>
            </div>

            <!-- <el-button slot="reference">click 激活</el-button> -->
            <el-button slot="reference" type="primary" @click="watchData(row)" size="mini"
              >{{$t('language.5o6upp1vows0')}}</el-button
            >
          </el-popover>
        </template>
      </basic-list>
    </template>
  </basic-dialog>
</template>

<script>
// 添加或编辑用户
import EntityDialog from "@/mixins/entityDialog";
import ExactList from "@/mixins/exactList";
import { mapState } from "vuex";
export default {
  mixins: [EntityDialog, ExactList],
  data() {
    return {
      rules: {},
      pageSize: 10,
      typeItem: "",
      roleNameLike: "",
      dataType: [],
      typeList: [],
      dataExtInfoList: [],
      apiIdList: [],
      pickIdList: [],
      adminList: {},
      selCode: "", // 保存选择的数据类型code
      fields: [{ key: "dataCode", name: this.$t('language.5o6umf8wqfc0') }],
      searchList: {},
      typeId: null,
      extendFieldEnumMap: {},
      dataCodeArray: [],
    };
  },
  computed: {
    ...mapState("app", ["tenementCode"]),
  },
  props: {
    selectItem: {
      type: Object,
      default() {
        return {};
      },
    },
    winClose: {
      type: Function,
      default() {
        return () => {};
      },
    },
    commit: Function,
  },
  watch: {
    "state.adminList2": {
      deep: true,
      immediate: true,
      handler: function (newVal) {
        this.adminList = newVal;
        // 默认值
        // this.giveCheck()
      },
    },
    "state.dataType2": {
      deep: true,
      immediate: true,
      handler: function (newVal) {
        this.dataType = newVal;
        // 设置默认选项和查询
        newVal[0] && (this.typeItem = newVal[0].typeCode);
        newVal[0] && this.dtTypeChange(newVal[0].typeCode);
      },
    },
  },
  methods: {
    query() {
      this.dtTypeChange(this.selCode, true);
    },
    handleReset() {
      this.searchList = {};
      if (this.dataType.length) {
        this.typeItem = this.dataType[0].typeCode;
        this.dtTypeChange(this.typeItem);
      }
    },
    handleOk() {},
    // 类型选择回调
    dtTypeChange(code, flag) {
      this.selCode = code;
      if (!flag) {
        this.searchList = {};
      }
      let getitem = this.dataType.filter((ev) => {
        return code === ev.typeCode;
      });
      this.dataExtInfoList = this.handleSetSearch(getitem[0].dataExtInfoList);
      this.fields = [{ key: "dataCode", name: this.$t('language.5o6umf8wqfc0') }];
      this.typeId = getitem[0].id;
      this.$parent.updateState({
        entity: { searchList: this.searchList, typeId: getitem[0].id },
      });
      this.$parent.dispatch("queryUserBaseData").then((_data) => {
        // 判断是否有数据
        this.$parent.adminDialogHasData = _data.length > 0;
        this.dataExtInfoList.forEach((ev) => {
          const col = _.pick(ev, ["key", "name"]);
          if (ev.type === "enums") {
            col.render = (h, { row }) => {
              const itemEnum = this.extendFieldEnumMap[col.key].find(
                (item) => item.value === row[col.key]
              );
              const value = itemEnum ? itemEnum.label : "";
              return <span>{value}</span>;
            };
          }
          this.fields.push(col);
        });
        // 如果没有row数据项的话放一个空项占位
        if (this.dataExtInfoList.length === 0) {
          this.fields.push({
            key: "-",
            name: "-",
          });
        }
      });
    },
    // 关闭和取消按钮
    handleClose(ev) {
      this.winClose(ev);
    },
    // actionRender(h, { index, row, col }){
    //   return  <el-button type="primary" onClick={ (e,row) => this.watchData(e,row)} size="mini">查看</el-button>
    // },
    watchData({ row }) {
      let params = {
        id: row.id,
        tenementCode: this.tenementCode,
        userId: this.$store.state.users.userId,
      };
      api.users.queryUserBaseDataAssignSource({ data: params }).then((res) => {
        if (res.code == 200) {
          this.dataCodeArray = res.data;
        } else {
          this.$message({ message: res.msg || this.$t('language.5o6upp1vp910'), type: "error" });
        }
      });
    },
    handleChange(ev) {},
    // 选择触发事件 获取当前行数据
    selectionChange(rows, ind) {
      this.pickIdList.length = 0;
      rows.forEach((item) => {
        this.pickIdList.push(item.id);
      });
      this.$parent.updateState({ pickIdList: this.pickIdList });
    },
    giveCheck() {
      // 设置数据勾选
      const self = this;
      this.$nextTick(() => {
        this.apiIdList.length = 0;
        const _table = self.$refs.adminTB && self.$refs.adminTB.$refs.table;
        this.adminList &&
          this.adminList.list &&
          this.adminList.list.forEach((item, ind) => {
            // 设置状态
            item && _table.toggleRowSelection(item, item.isOwnData === 1);
            // 存储id
            this.apiIdList.push(item.id);
          });
        if (this.apiIdList.length > 0) {
          this.$parent.updateState({ apiIdList: this.apiIdList });
        }
      });
    },
    // 切换页数
    pageIndexChange(_index) {
      let _ind = _index - 1;
      // 更新页面数据
      // this.pageSize = _ind
      this.$parent.updateState({ adminPageIndex: _ind });
      // 查询列表
      this.$parent.dispatch("queryUserBaseData");
    },
    // 切换每页显示条数
    pageSizeChange(_size) {
      // 查询列表
      this.pageSize = _size;
      this.$parent.updateState({ adminPageSize: _size });
      // 查询列表
      this.$parent.dispatch("queryUserBaseData");
    },
    handleSetSearch(array) {
      array = array || [];
      array = array.filter((item) => item.isEffective === 1);
      const result = [];
      this.extendFieldEnumMap = {};
      array.forEach((item) => {
        const row = {
          key: `ext${item.extNo}`,
          name: item.extName,
          value: undefined,
          type: "input",
        };
        if (item.isEnum == 1) {
          row.type = "enums";
          row.enums = jt.fn.generateEnums(item.enumValue, ",");
          this.extendFieldEnumMap[row.key] = _.cloneDeep(row.enums);
        }
        result.push(row);
      });
      return result;
    },
    async querySearchThink(value, cb, key) {
      const query = {
        ...this.searchList,
        typeId: this.typeId,
        tenementCode: this.tenementCode,
        userId: this.$store.state[this.$parent.storeKey].userId,
      };
      const params = { data: query, page: { pageIndex: 1, pageSize: 10 } };
      const { data, msg, code } = await api.users.queryUserBaseData(params);
      if (code === 200) {
        data.rows = data.rows || [];
        const array = Array.from(new Set(data.rows.map((item) => item[key])));
        const result = array.map((item) => ({ value: item }));
        cb(result);
      } else {
        cb();
      }
    },
  },
};
</script>

<style lang="scss" scope>
/deep/ .el-form {
  width: 100%;
}
.entity-dlg__block-bd.formFix {
  input {
    width: 200px;
  }
  .col-r {
    float: right;
    position: relative;
    padding: 0 12px 0 25px;
    width: 162px;
    .el-button {
      width: 75px;
    }
  }
}
</style>
